export default __webpack_public_path__ + "static/media/glass-icon.e80b0804.svg";